// extracted by mini-css-extract-plugin
module.exports = {"confirmModal":"_435sR","checkbox":"_22Ffi","content":"y6JJq","dot":"_91Eja"};